const ITEMS = [
  "Luxury Crafted Around Your Lifestyle",
  "Modular Kitchens",
  "Villa Interiors",
  "Designed for Living. Built to Inspire.",
  "Premium Materials",
  "Apartment Interiors",
  "Where Beautiful Homes Begin",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-b hairline bg-[#F7F5F2] py-6" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className={`font-display text-2xl md:text-3xl ${i % 2 === 0 ? "italic text-[#1B1B1B]" : "text-outline font-num uppercase tracking-widest text-xl md:text-2xl"}`}>
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#B68D40]" />
          </span>
        ))}
      </div>
    </div>
  );
}
